import React from 'react';
import styled from 'styled-components';

import Section from '@/components/templates/doctor/detail/components/Section/Section';
import { DoctorBadge } from '@/types/doctor';

interface Props {
  doctorBadges: Array<DoctorBadge>;
}

const DoctorBadges = ({ doctorBadges }: Props) => {
  return (
    <>
      <Section>
        <Section.Title title={'의사 정보'} />
        <Badges>
          {doctorBadges.map((badge, index) => (
            <Badge key={`badge_${index}`}>
              <BadgeIcon src={badge.iconUrl} />
              <BadgeContentWrap>
                <BadgeTitle>{badge.title}</BadgeTitle>
                <BadgeDescription>{badge.description}</BadgeDescription>
              </BadgeContentWrap>
            </Badge>
          ))}
        </Badges>
      </Section>
    </>
  );
};

export default DoctorBadges;

const Badges = styled.div`
  display: flex;
  padding: 0 24px;
  gap: 20px;
  flex-wrap: wrap;
  align-self: stretch;
  flex-direction: column;
`;

const Badge = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
`;

const BadgeIcon = styled.img`
  width: 32px;
  height: 32px;
  margin-right: 16px;
`;

const BadgeContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
const BadgeTitle = styled.div`
  ${({ theme }) => `
    ${theme.typography.UI15SB}
    color: ${theme.color.gray700}
  `}
`;
const BadgeDescription = styled.div`
  ${({ theme }) => `
    ${theme.typography.UI12R}
    color: ${theme.color.gray300}
  `}
`;
